import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'
import { TableData } from 'utils/data'

export const fetchSalesAreaOfStore = fetchGeneralData<TableData>(
    `${ApiSubUrls[Apis.AGGREGATIONS]}/sales/work_areas`,
)
